module.exports = __webpack_public_path__ + "staticPO/img/paysuccess.0a17aa9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paysuccess.gif
// module id = MrnQ
// module chunks = 1